// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"style_tabsContainer__1VDsE","buttonContainer":"style_buttonContainer__1yzKN","selected":"style_selected__3rlwp","tabsContent":"style_tabsContent__1eLVL"};